// extracted by mini-css-extract-plugin
export default {"arrow":"backArrowButton_arrow__iCcPc","arrowLeft":"backArrowButton_arrowLeft__7APTn"};